import { icon, JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { GraphVertex } from '../types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1),
      maxHeight: 415,
      overflowY: 'auto',
    },
    listItem: {
      cursor: 'pointer',
      '&:hover': {
        background: theme.palette.grey[300],
      },
    },
    listItemText: {
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': '3',
      overflow: 'hidden',
    },
    itemRoot: {
      alignItems: 'flex-start',
    },
    iconRoot: { minWidth: theme.spacing(4.5) },
  })
);

interface Props {
  open: boolean;
  vertices: GraphVertex[];
  selectedNodeId?: string | null;
  onSelectNode: (id: string) => void;
  classes?: { paper?: any; list?: any };
}

const sortAlphabetically = (a: GraphVertex, b: GraphVertex) => {
  // Use toUpperCase() to ignore character casing
  const nameA = a?.entity?.displayName?.toUpperCase() || 'unknown';
  const nameB = b?.entity?.displayName?.toUpperCase() || 'unknown';

  let comparison = 0;
  if (nameA > nameB) {
    comparison = 1;
  } else if (nameA < nameB) {
    comparison = -1;
  }
  return comparison;
};

const getIcon = (vertex: GraphVertex) => {
  const Icon = icon.get(icon.entityToPath(vertex.entity));
  return <Icon />;
};

const PackContextMenu = ({
  vertices,
  open,
  selectedNodeId,
  onSelectNode,
  classes: propClasses,
}: Props) => {
  const classes = useStyles();
  return (
    <Collapse in={open} mountOnEnter unmountOnExit>
      <Paper className={clsx(classes.paper, propClasses?.paper)}>
        <List classes={{ root: propClasses?.list }}>
          {vertices.sort(sortAlphabetically).map((v) => (
            <ListItem
              selected={v.id === selectedNodeId}
              onClick={() => onSelectNode(v.id)}
              className={classes.listItem}
              key={v.id}
              classes={{ root: classes.itemRoot }}
            >
              <ListItemIcon classes={{ root: classes.iconRoot }}>
                {getIcon(v)}
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary={v?.entity?.displayName || 'No display name'}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Collapse>
  );
};

export default PackContextMenu;
